module.exports = __webpack_public_path__ + "img/bf_gocase.a7029bb.webp";